import { RootState } from "@/app/stores";
import { createSelector } from "@reduxjs/toolkit";

const baseSelector = createSelector(
    (state: RootState) => state,
    (state) => state.sidebar
)

export const selectSidebarType = createSelector(
    baseSelector,
    (state) => state.type
)